export const getDates = (today: any) => {
  const dates = [];

  for (let i = -7; i <= 7; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    dates.push({
      value: date.toISOString().split("T")[0],
      label: date.toISOString().split("T")[0], // Format as YYYY-MM-DD
    });
  }
  return dates;
};
export const getHoursList = (runwayDataResponse: any) => {
  const { timeseriesData } = runwayDataResponse;
  return timeseriesData.map((data: any) => {
    const hour = data.time;
    const label = `${hour}`;
    return { time: label, capacity: data.capacity };
  });
};
